import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import GenericContent from "../../services/GenericContent";
import Box from "@mui/material/Box";
import CountdownTimer from "../CountDownTime";
import Rating from "../Rating";
import RatingResullt from "../RatingResullt";
import sanitizeHtml from "sanitize-html";
import { Parser } from "html-to-react";
import "./styles.scss";
import {
  ButtonTypes,
  CommonContent,
  Content,
  ContentKey,
  ContentType,
  RatingLabels,
} from "../../types/Types";
import {
  GameDetails,
  GameMode,
  Player,
  RatingScore,
  UserAccount,
} from "../../types/Game";
import GameHelper from "../../services/GameHelper";
import Firebase from "../../services/Firebase";
import { useGlobalAudioPlayer } from "react-use-audio-player";
import ButtonSound from "./../../assets/sounds/click-boton.mp3";
import AllVotesSound from "./../../assets/sounds/fin-votacion.mp3";
import Alert from "@mui/material/Alert";
import { motion } from "framer-motion";

export type GreenCardDataProps = {
  timeOut: number;
  title: string;
  body: string;
  continuePlayingLabel: string;
  sendAnswerLabel: string;
  sendAnLabel: string;
  rightAnswerLabel: string;
  wrongAnswerLabel: string;
  timeoutLabel: string;
  finalEvaluation: string;
};

export type GreenCardProps = {
  content: CommonContent[];
  players: Player[];
  reviewerMode?: boolean;
  data: GreenCardDataProps;
  ratingLabels: RatingLabels;
  onTimeOut: () => void;
  onCardAnswer: (answer: string) => void;
  onTyping: (answer: string) => void;
  isUsersTurn: boolean;
  game: GameDetails;
  user: UserAccount;
  card: Content;
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
}

export default function GreenCard(props: GreenCardProps) {
  const { load } = useGlobalAudioPlayer();
  const { data, reviewerMode, ratingLabels } = props;
  const [open, setOpen] = React.useState(false);
  const [answer, setAnswer] = React.useState("");
  const [next, setNext] = React.useState(false);
  const [score, setScore] = React.useState<RatingScore | null>();
  const [rated, setRated] = React.useState(0);
  const [ratedSent, setRatedSent] = React.useState(false);
  const [rateSelected, setRateSelected] = React.useState(false);

  React.useEffect(() => {
    console.log("Green card has rendered:", data);
    setOpen(true);
  }, [data]);

  React.useEffect(() => {
    if (hasEveryBodyVoted() && !next) {
      setNext(true);
      playAllVotesSound();
      if (props.isUsersTurn) {
        setTimeout(() => {
          props.onTimeOut();
        }, 5000);
      }
    }
  }, [score]);

  React.useEffect(() => {
    props.onTyping(answer);
    Firebase.listentGreenCardRating(
      props.game.turnUserId,
      props.game.gameId,
      props.card.id,
      () => {
        getTotalScore()
          .then()
          .catch((e) => {
            console.error(e);
          });
      }
    );
  }, [answer]);

  const sendAnswer = () => {
    playButtonSound();
    props.onCardAnswer(answer);
  };

  const rateCard = async (score: number) => {
    console.log("rateCard:", score);
    setRated(score);
    setRateSelected(true)
  };

  const sendRateCard = async () => {
    playButtonSound();
    setRatedSent(true);
    await GameHelper.rateGreenCard({
      gameId: props.game.gameId,
      userId: props.game.turnUserId,
      cardId: props.card.id,
      score: rated,
    });
  };

  const getTotalScore = async () => {
    const total = await GameHelper.getGreenCardScore(
      props.card.id,
      props.game.gameId,
      props.game.turnUserId
    );
    console.log("Total score:", total);
    setScore(total);
  };

  const playButtonSound = () => {
    load(ButtonSound, {
      autoplay: true,
    });
  };

  const playAllVotesSound = () => {
    load(AllVotesSound, {
      autoplay: true,
    });
  };

  const hasEveryBodyVoted = () => {
    const isReady =
      props.players &&
      props.players.length > 1 &&
      score &&
      score?.votes >= props.players.length - 1;
    return isReady;
  };

  return (
    <Box>
      <BootstrapDialog
        className="titleDialogGreen  dialogContainer"
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title">
          {data.title}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography className="questionTextDialog" gutterBottom>
            {Parser().parse(sanitizeHtml(data.body))}
          </Typography>
          {props.isUsersTurn && !props.game.cardAnswer && (
            <TextareaAutosize
              onChange={(event) => {
                setAnswer(event.target.value);
              }}
              maxRows={10}
              minRows={8}
              className="inputTextGrey"
            />
          )}
          {!props.isUsersTurn && props.game.tempCardAnswer && (
            <div className="blured-text divTextDialog">
              <div className="divAnswer">{props.game.tempCardAnswer}</div>
            </div>
          )}

          {props.game.cardAnswer && (
            <div className="divTextDialog"><div className="divAnswer">{props.game.cardAnswer}</div></div>
          )}

          {props.isUsersTurn && answer && !props.game.cardAnswer && (
            <div className="areaButtonTextDialog">
              <Button
                onClick={sendAnswer}
                className="buttonTextDialog"
                variant="contained"
              >
                {data.sendAnswerLabel}
              </Button>
            </div>
          )}

          {props.isUsersTurn && answer && props.game.cardAnswer && score &&  props.game.mode !== GameMode.PlayAlone && (
            <div className="divTextDialog">
              {data.finalEvaluation}
              <RatingResullt score={score.total} />
              {!hasEveryBodyVoted() && (
                <Alert severity="warning">
                  {" "}
                  {GenericContent.getKeyValue(
                    props.content,
                    ContentKey.RATING_WAITING_LABEL
                  )}{" "}
                  {score.votes}{" "}
                  {GenericContent.getKeyValue(
                    props.content,
                    ContentKey.RATING_PLAYERS_LABEL
                  )}{" "}
                  {props.players.length - 1}
                </Alert>
              )}
            </div>
          )}

          {!props.isUsersTurn && props.game.cardAnswer && (
            <div className="divTextDialog">
              {data.finalEvaluation}
              <Rating onRate={rateCard} ratingLabels={ratingLabels} />
              <div className="areaButtonTextDialog">
                {!ratedSent && rateSelected && (
                  <motion.div
                    animate={{ scaleX: 1.1 }}
                    transition={{ repeat: Infinity, duration: 1 }}
                  >
                    <Button
                      disabled={ratedSent}
                      onClick={sendRateCard}
                      className="buttonTextDialog"
                      variant="contained"
                    >
                      { Parser().parse(GenericContent.getButtonName(
                        props.content,
                        ButtonTypes.RATING_LABEL
                      ))}
                    </Button>
                  </motion.div>
                )}
              </div>
            </div>
          )}

          <div>
            {hasEveryBodyVoted() && (
              <Alert severity="success">
                {Parser().parse(GenericContent.getKeyValue(
                  props.content,
                  ContentKey.RATING_FINISHED_LABEL
                ))}

              </Alert>
            )}
          </div>

          <div>
            {!hasEveryBodyVoted() &&
              props.game.cardAnswer &&
              !props.isUsersTurn &&
              score && (
                <>
                 <motion.div
                    animate={{ rotateY:15  }}
                    transition={{ repeat: Infinity, duration: 2 }}
                  >
                  <Alert severity="warning">
                    {}
                    {GenericContent.getKeyValue(
                      props.content,
                      ContentKey.RATING_WAITING_LABEL
                    )}{" "}
                    {score.votes}{" "}
                    {GenericContent.getKeyValue(
                      props.content,
                      ContentKey.RATING_PLAYERS_LABEL
                    )}{" "}
                    {props.players.length - 1}
                  </Alert>
                  </motion.div>
                </>
              )}
          </div>

          <CountdownTimer
            time={props.data.timeOut}
            onTimeOut={() => {
              props.onTimeOut()
            }}
          />
        </DialogContent>
        <DialogActions>
          {(next && props.isUsersTurn) ||
            (props.game.mode === GameMode.PlayAlone && (
              <Button
                onClick={() => {
                  playButtonSound();
                  props.onTimeOut();
                }}
              >
                {data.continuePlayingLabel}
              </Button>
            ))}
        </DialogActions>
      </BootstrapDialog>
    </Box>
  );
}
